import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import { CreatedToast, ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function SweetShopDEtails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/SweetShopPd/items/getbyshopid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })

            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])


    const [sweetsData, setSweetsData] = useState([])

    const AllSweetsItems = async () => {
        try {
            const profileId = JSON.parse(sessionStorage.getItem('businessPd'))
            const response = await axios.get(`${Api_Url}api/v1/Item/getitembyprofileid/${profileId.profileId}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSweetsData(response.data.data)
        } catch (error) {
            return error
        }
    }

    useEffect(() => {
        AllSweetsItems()
    }, [])

    const AllSweetsFetch = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/SweetShopPd`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
        } catch (error) {
            return error
        }
    }

    useEffect(() => {
        AllSweetsFetch()
    }, [])

    const [sweetShopData, setSweetShopData] = useState({

        sweetShopPdId: id,
        itemId: 0,
        sellingQuantity: 0,
        sellingPrice: 0,
        totalSellingAmount: 0,
        actualPrice: 0,
        totalActualAmount: 0,
        grossProfit: 0,
        latitude: "",
        longitude: ""

    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setSweetShopData({ ...sweetShopData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/SweetShopPd/item`, sweetShopData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleCancel()
                getSingleUser()
            }
           
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }


    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/SweetShopPd/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSweetShopData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/SweetShopPd/item/${id}`, sweetShopData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Updated Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("something Went Wrong")
            return error
        }
    }

    const columns = [
        {
            title: "Item Name",
            dataIndex: "itemName",
            // render: (text, record) => (
            //     <div>
            //         {text}
            //         <Link
            //             to={rawmaterial/${record.id}}
            //         >
            //             <h5>{record.itemName}</h5>
            //         </Link>
            //     </div>
            // ),
        },
        {
            title: "Selling Price",
            dataIndex: "sellingPrice",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Sellng Quantity",
            dataIndex: "sellingQuantity",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Total Selling",
            dataIndex: "totalSellingAmount",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Gross Profit",
            dataIndex: "grossProfit",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Actual Price",
            dataIndex: "actualPrice",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Total Actual Amount",
            dataIndex: "totalActualAmount",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => (
              <Link to={`rawmaterial/${record.id}`}>
                <Button type="primary" icon={<i className="fa-solid fa-eye"></i>}>
                </Button>
              </Link>
            ),
          },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        // className='btn btn-secondary'
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
        // {
        //     title: 'Delete',
        //     dataIndex: 'delete',
        //     // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
        //     render: (text, record) => (
        //         <div>
        //             {text}
        //             <Button
        //                 className='btn btn-danger'
        //                 type="primary"
        //                 // onClick={() => handleClick(record.id)}
        //                 style={{ marginLeft: '10px' }}
        //             >
        //                 <i class="fa-solid fa-trash"></i>
        //             </Button>
        //         </div>
        //     ),
        // },
    ];

    const calculateTotalReciepts = () => {
        const result = sweetShopData.sellingQuantity * sweetShopData.sellingPrice || 0;

        setSweetShopData(prev => ({
            ...prev,
            totalSellingAmount: result
        }))
    };

    useEffect(() => { calculateTotalReciepts() }, [sweetShopData.sellingQuantity, sweetShopData.sellingPrice])


    async function handleCancel() {
        setSweetShopData({
            ...sweetShopData,
            sweetShopPdId: id,
            itemId: 0,
            sellingQuantity: 0,
            sellingPrice: 0,
            totalSellingAmount: 0,
            actualPrice: 0,
            totalActualAmount: 0,
            grossProfit: 0,
        })
        // reset form with initial value 0
        setIsModalOpen(false);
        setIsEditModalOpen(false)
    }

    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Sweet Shop</h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Item</button>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title={<h4>Add Shop</h4>}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Add/Buisnss Shop</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Name Of Item:
                                    </label>
                                    <select className="form-control" value={sweetShopData.itemId} onChange={(e) => setSweetShopData({ ...sweetShopData, itemId: e.target.value })}>
                                        <option value="">Select Sweets</option>
                                        {sweetsData && sweetsData.length > 0 && sweetsData.map((res) => (
                                            <option value={res.id}>{res.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Quantity:(kg)
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Taking Time in minute" value={sweetShopData.sellingQuantity} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingQuantity: e.target.value })} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Price:(Kg)
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter Daily Grind In kg" value={sweetShopData.sellingPrice} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingPrice: e.target.value })} />
                                </div>
                            </div>
                        </div>
                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Total Reciepts: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {sweetShopData.totalSellingAmount.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
            {/* Edit modal */}
            <Modal
                title={<h4>Add Shop</h4>}
                open={isEditModalOpen}
                onOk={() => setIsEditModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                    <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(sweetShopData.id)}>Submit</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Add/Buisnss Shop</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Name Of Item:
                                    </label>
                                    <select className="form-control" value={sweetShopData.itemId} onChange={(e) => setSweetShopData({ ...sweetShopData, itemId: e.target.value })}>
                                        <option value="">Select Sweets</option>
                                        {sweetsData && sweetsData.length > 0 && sweetsData.map((res) => (
                                            <option value={res.id}>{res.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Quantity(kg):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Selling Quantity(kg)" value={sweetShopData.sellingQuantity} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingQuantity: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Price:(Kg)
                                    </label>
                                    <input className="form-control" type="text" placeholder="Selling Price:(Kg)" value={sweetShopData.sellingPrice} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingPrice: e.target.value })} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default SweetShopDEtails















// import React, { useEffect, useState } from 'react'
// import { Link, useParams } from 'react-router-dom'
// import { Api_Url } from '../../config/config'
// import axios from 'axios'
// import { Button, Divider, Modal, Table } from 'antd'
// import { CreatedToast, ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

// function SweetShopDEtails() {
//     const { id } = useParams()

//     const [singleData, setSingleData] = useState([])
//     const [isModalOpen, setIsModalOpen] = React.useState(false);
//     const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

//     const getSingleUser = async () => {
//         try {
//             const response = await axios.get(`${Api_Url}api/v1/SweetShopPd/items/getbyshopid/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })

//             console.log("tum hi ho", response.data.data)
//             setSingleData(response.data.data)
//         } catch (error) {
//             return error.message
//         }
//     }

//     useEffect(() => {
//         getSingleUser()
//     }, [])


//     const [sweetsData, setSweetsData] = useState([])

//     const AllSweetsItems = async () => {
//         try {
//             const profileId = JSON.parse(sessionStorage.getItem('businessPd'))
//             // console.log("profileId",profileId.profileId)
//             const response = await axios.get(`${Api_Url}api/v1/Item/getitembyprofileid/${profileId.profileId}`, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })
//             console.log("allsweets", response.data.data)
//             setSweetsData(response.data.data)
//         } catch (error) {
//             return error
//         }
//     }

//     useEffect(() => {
//         AllSweetsItems()
//     }, [])

//     const AllSweetsFetch = async () => {
//         try {
//             const response = await axios.get(`${Api_Url}api/v1/SweetShopPd`, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })
//             console.log(response.data.data)
//         } catch (error) {
//             return error
//         }
//     }

//     useEffect(() => {
//         AllSweetsFetch()
//     }, [])

//     const [sweetShopData, setSweetShopData] = useState({

//         sweetShopPdId: id,
//         itemId: 0,
//         sellingQuantity: 0,
//         sellingPrice: 0,
//         totalSellingAmount: 0,
//         actualPrice: 0,
//         totalActualAmount: 0,
//         grossProfit: 0,
//         latitude: "",
//         longitude: ""

//     })

//     useEffect(() => {
//         if ("geolocation" in navigator) {
//             navigator.geolocation.getCurrentPosition(function (position) {

//                 const { latitude, longitude } = position.coords;
//                 setSweetShopData({ ...sweetShopData, latitude: latitude.toString(), longitude: longitude.toString() });
//             });
//         } else {
//             console.log("Geolocation is not supported by this browser.");
//         }
//     }, [])

//     const handleSubmit = async () => {
//         try {
//             const response = await axios.post(`${Api_Url}api/v1/SweetShopPd/item`, sweetShopData, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })
//             console.log("response", response)
//             getSingleUser()
//             setIsModalOpen(false)
//         } catch (error) {
//             return error.message
//         }
//     }


//     const handleClick = async (id) => {
//         // console.log("id",id)
//         try {
//             const response = await axios.get(`${Api_Url}api/v1/SweetShopPd/item/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })
//             console.log("all data", response.data.data)
//             if (response.data.succeeded) {
//                 CreatedToast("Created Successfully")
//                 handleCancel()
//                 getSingleUser()
//             }
//         } catch (error) {
//             ErrorToast("Something Went Wrong")
//             return error.message
//         }
//     }


//     //update Method

//     const handleUpdate = async (id) => {
//         console.log("kkk", id)
//         try {
//             const response = await axios.post(`${Api_Url}api/v1/SweetShopPd/item/${id}`, sweetShopData, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })
//             console.log("updateed", response.data)
//             if (response.data.succeded) {
//                 UpdatedToast("Updated Successfully")
//                 handleCancel()
//                 getSingleUser()
//             }
//         } catch (error) {
//             ErrorToast("something Went Wrong")
//             return error
//         }
//     }

//     console.log("mmm", sweetsData)


//     const columns = [
//         {
//             title: "Item Name",
//             dataIndex: "itemNam",
//             sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
//             render: (text, record) => (
//                 <div>
//                     {text}
//                     <Link
//                         to={`rawmaterial/${record.id}`}
//                     >
//                         <h5>{record.itemName}</h5>
//                     </Link>
//                 </div>
//             ),
//         },
//         {
//             title: "Selling Price",
//             dataIndex: "sellingPrice",
//             sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
//         },
//         {
//             title: "Sellng Quantity",
//             dataIndex: "sellingQuantity",
//             sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
//         },
//         {
//             title: "Total Selling",
//             dataIndex: "totalSellingAmount",
//             sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
//         },
//         {
//             title: "Gross Profit",
//             dataIndex: "grossProfit",
//             sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
//         },
//         {
//             title: 'Edit',
//             dataIndex: 'edit',
//             sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
//             render: (text, record) => (
//                 <div>
//                     {text}
//                     <Button
//                         type="primary"
//                         onClick={() => handleClick(record.id)}
//                         style={{ marginLeft: '10px' }}
//                     >
//                         <i class="fa-solid fa-pen-to-square"></i>
//                     </Button>
//                 </div>
//             ),
//         },
//     ];

//     const calculateTotalReciepts = () => {
//         const result = sweetShopData.sellingQuantity * sweetShopData.sellingPrice || 0;

//         setSweetShopData(prev => ({
//             ...prev,
//             totalSellingAmount: result
//         }))
//     };

//     useEffect(() => { calculateTotalReciepts() }, [sweetShopData.sellingQuantity, sweetShopData.sellingPrice])


//     async function handleCancel() {
//         setSweetShopData({
//             ...sweetShopData,
//             sweetShopPdId: id,
//             itemId: 0,
//             sellingQuantity: 0,
//             sellingPrice: 0,
//             totalSellingAmount: 0,
//             actualPrice: 0,
//             totalActualAmount: 0,
//             grossProfit: 0,
//         })
// // reset form with initial value 0
//         setIsModalOpen(false);
//         setIsEditModalOpen(false)
//     }
    

//     return (

//         <>
//             <div className="page-wrapper">
//                 <div className="content container-fluid">
//                     <div className="row">
//                         <div className="col-12 d-flex align-items-center justify-content-between">
//                             <h3 className="mb-0">Sweet Shop</h3>
//                             <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Item</button>
//                         </div>
//                     </div>

//                     <div className="row mt-4">
//                         <div className="col-12 mx-auto">
//                             <Table
//                                 className="table-striped"
//                                 style={{ overflowX: "auto" }}
//                                 columns={columns}
//                                 dataSource={singleData}
//                                 rowKey={(record) => record.id}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Modal
//                 title={<h4>Add Shop</h4>}
//                 open={isModalOpen}
//                 onOk={() => setIsModalOpen(false)}
//                 onCancel={() => handleCancel()}
//                 footer={[
//                     <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
//                 ]}
//                 width={600}
//                 mask={false}
//                 maskClosable={false}
//             >
//                 <div className="modal-body mt-5">
//                     <form>
//                         <Divider>Add/Buisnss Shop</Divider>
//                         <div className="row">
//                             <div className="col-sm-6">
//                                 <div className="input-block mb-3">
//                                     <label className="col-form-label">
//                                         Name Of Item:
//                                     </label>
//                                     <select className="form-control" value={sweetShopData.itemId} onChange={(e) => setSweetShopData({ ...sweetShopData, itemId: e.target.value })}>
//                                         <option value="">Select Sweets</option>
//                                         {sweetsData && sweetsData.length > 0 && sweetsData.map((res) => (
//                                             <option value={res.id}>{res.name}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>
//                             <div className="col-sm-6">
//                                 <div className="input-block mb-3">
//                                     <label className="col-form-label">
//                                         Selling Quantity:(kg)
//                                     </label>
//                                     <input className="form-control" type="number" placeholder="Enter Taking Time in minute" value={sweetShopData.sellingQuantity} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingQuantity: e.target.value })} />
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="row">
//                             <div className="col-sm-6">
//                                 <div className="input-block mb-3">
//                                     <label className="col-form-label">
//                                         Selling Price:(Kg)
//                                     </label>
//                                     <input className="form-control" type="text" placeholder="Enter Daily Grind In kg" value={sweetShopData.sellingPrice} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingPrice: e.target.value })} />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row my-3">
//                             <div className="col-sm-12 d-flex align-items-center justify-content-between">
//                                 <p className="mb-0">Total Reciepts: </p>
//                                 <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {sweetShopData.totalSellingAmount.toFixed(2)}</span>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </Modal>

//             {/* Edit modal */}


//             <Modal
//                 title={<h4>Add Shop</h4>}
//                 open={isEditModalOpen}
//                 onOk={() => setIsEditModalOpen(false)}
//                 onCancel={() => handleCancel()}
//                 footer={[
//                     <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(sweetShopData.id)}>Submit</button>
//                 ]}
//                 width={600}
//                 mask={false}
//                 maskClosable={false}
//             >
//                 <div className="modal-body mt-5">
//                     <form>
//                         <Divider>Add/Buisnss Shop</Divider>
//                         <div className="row">
//                             <div className="col-sm-6">
//                                 <div className="input-block mb-3">
//                                     <label className="col-form-label">
//                                         Name Of Item:
//                                     </label>
//                                     <select className="form-control" value={sweetShopData.itemId} onChange={(e) => setSweetShopData({ ...sweetShopData, itemId: e.target.value })}>
//                                         <option value="">Select Sweets</option>
//                                         {sweetsData && sweetsData.length > 0 && sweetsData.map((res) => (
//                                             <option value={res.id}>{res.name}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>
//                             <div className="col-sm-6">
//                                 <div className="input-block mb-3">
//                                     <label className="col-form-label">
//                                         Selling Quantity(kg):
//                                     </label>
//                                     <input className="form-control" type="number" placeholder="Selling Quantity(kg)" value={sweetShopData.sellingQuantity} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingQuantity: e.target.value })} />
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="row">
//                             <div className="col-sm-6">
//                                 <div className="input-block mb-3">
//                                     <label className="col-form-label">
//                                         Selling Price:(Kg)
//                                     </label>
//                                     <input className="form-control" type="text" placeholder="Selling Price:(Kg)" value={sweetShopData.sellingPrice} onChange={(e) => setSweetShopData({ ...sweetShopData, sellingPrice: e.target.value })} />
//                                 </div>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </Modal>
//         </>
//     )
// }

// export default SweetShopDEtails
